module.exports = __webpack_public_path__ + "media/role_selection/full_service-b079e366.png";